import { c as _c } from "react/compiler-runtime";
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import Link from 'components/consumer/Link';
import JBLogo from 'components/consumer/jb-logo';
import useStoreDetails from 'hooks/useStoreDetails';
import getIsClient from 'commons/isClient';
const getIsPrideMonth = () => {
  const currentDate = new Date();
  // The month is 0-based, so we need to add 1 to get the correct month number
  const currentMonthNumber = currentDate.getMonth() + 1;
  // Pride Month is June, so if the month number is 6, we're in Pride Month
  return currentMonthNumber === 6;
};
const IconJoybirdLogoPride = loadable(() => import('components/icons/IconJoybirdLogoPride'));
const LogoLink = t0 => {
  const $ = _c(13);
  const {
    className: t1,
    to: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const to = t2 === undefined ? "/" : t2;
  const storeDetails = useStoreDetails();
  const storeName = storeDetails?.name;
  const [isClient, setIsClient] = useState(false);
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const isRunningOnClient = getIsClient();
      setIsClient(isRunningOnClient);
    };
    t4 = [];
    $[0] = t3;
    $[1] = t4;
  } else {
    t3 = $[0];
    t4 = $[1];
  }
  useEffect(t3, t4);
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = getIsPrideMonth();
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const isPrideMonth = t5;
  const t6 = `items-center rounded-sm border-2 border-solid border-transparent inline-flex justify-center p-2 absolute no-underline left-[60px] min-h-12 lg:relative lg:left-[-6px] ${className}`;
  const t7 = isClient ? "client" : "server";
  let t8;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = isPrideMonth ? <IconJoybirdLogoPride className="relative top-0.5 lg:static lg:top-0" /> : <JBLogo />;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  let t9;
  if ($[4] !== t7) {
    t9 = <Fragment key={t7}>{t8}</Fragment>;
    $[4] = t7;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  if ($[6] !== storeName) {
    t10 = !!storeName && <span className="text-xs ml-2 pt-2 color-gray font-script">{storeName}</span>;
    $[6] = storeName;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== t10 || $[9] !== t6 || $[10] !== t9 || $[11] !== to) {
    t11 = <Link className={t6} to={to} data-xc="joybird_logo">{t9}{t10}</Link>;
    $[8] = t10;
    $[9] = t6;
    $[10] = t9;
    $[11] = to;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  return t11;
};
LogoLink.propTypes = {
  className: PropTypes.string,
  to: PropTypes.string
};
export default LogoLink;